import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { auth } from './firebase';

// WebRTC polyfills for older browsers
// @ts-ignore
window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
// @ts-ignore
window.RTCSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;
// @ts-ignore
window.RTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;

// Create the root only once
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

// Make sure Firebase auth is initialized before rendering
// to avoid flashing unauthenticated state
let authInitialized = false;

// Reset auth status to help with debugging
localStorage.setItem('authStatus', 'initializing');
console.log('Auth initialization started at:', new Date().toISOString());

// Add a timeout to detect stuck authentication
const authTimeout = setTimeout(() => {
  console.error('Auth initialization timed out after 10 seconds!');
  localStorage.setItem('authStatus', 'timeout');
  
  // Render the app anyway to prevent permanent loading
  if (!authInitialized) {
    authInitialized = true;
    
    console.log('Rendering app after auth timeout');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}, 10000);

// Listen for auth state changes just once (this is crucial!)
auth.onAuthStateChanged((user) => {
  // Clear the timeout since auth state changed
  clearTimeout(authTimeout);
  
  console.log('Auth state changed at:', new Date().toISOString());
  console.log('User authenticated:', user ? 'Yes' : 'No');
  
  localStorage.setItem('authStatus', user ? 'authenticated' : 'not-authenticated');
  
  // Only render the first time auth is initialized
  if (!authInitialized) {
    authInitialized = true;
    
    // Render our app once auth is ready
    console.log('Rendering app after auth initialization');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
